<div *ngIf="!loading"
    class="fixed w-full h-full inset-0 flex items-center justify-center bg-main-background bg-opacity-75 z-30 gap-4 overflow-y-auto"
    (click)="$event.preventDefault(); handleCloseFileUpload();">
    <div class="w-full max-h-full max-w-screen-md flex flex-row gap-1 justify-center overflow-y-auto"
        (click)="$event.stopPropagation()">
        <div
            class="w-full h-full overfow-y-auto flex min-w-full bg-white p-10 rounded-md text-center shadow-lg overflow-y-auto">
            <form (ngSubmit)="$event.preventDefault();" class="w-full flex flex-col items-center justify-start gap-4">
                <div class="w-full flex flex-col items-center justify-between gap-4">
                    <div class="w-full">
                        <h3 class="w-full text-xl oswald-font text-nside-orange-400 text-start">Upload files</h3>
                        <p class="w-full text-start">Upload documents you want to share with your team</p>
                    </div>

                    <div class="w-full flex items-stretch justify-center gap-4">
                        <div class="flex w-full h-full">
                            <label for="dropzone-file"
                                class="flex flex-col justify-center w-full h-64 border-2 border-dashed rounded-lg cursor-pointer"
                                (drop)="handleFileDrop($event)" (dragover)="onDragOver($event)"
                                (dragleave)="onDragLeave($event)" [ngClass]="{ 
                                'border-gray-300 bg-gray-50': !isDragging,
                                'border-nside-orange-400 bg-orange-50': isDragging 
                                }">

                                <div class="flex flex-col items-center justify-center pt-5 pb-6">
                                    <lucide-icon [name]="icons.CloudUpload" [size]="40"></lucide-icon>
                                    <p class="mb-2 text-sm text-gray-500">
                                        <span class="font-semibold">Click to upload</span> or drag and drop
                                    </p>
                                    <p class="text-xs text-gray-500">
                                        PDF, PNG, JPG or CSV (MAX. 2MB)
                                    </p>
                                    <div class="w-full text-center italic text-xs text-red-500"
                                        *ngIf="filesControl.invalid && filesControl.touched">
                                        <div *ngIf="filesControl.hasError('invalidType')">
                                            Invalid file type. Please upload a PDF, PNG, JPG, or CSV.
                                        </div>
                                        <div *ngIf="filesControl.hasError('maxSizeExceeded')">
                                            File size exceeds 2MB limit.
                                        </div>
                                    </div>
                                </div>
                                <input noEmoji id="dropzone-file" type="file" class="hidden" multiple
                                    (change)="onFilesSelected($event)" />
                            </label>
                        </div>

                        <div class="flex flex-col w-full h-64 overflow-y-auto items-start justify-start gap-2">
                            <ng-container *ngIf="filesControl.invalid && selectedFiles.length > 0;">
                                <div *ngFor="let file of selectedFiles"
                                    class="w-full p-2 flex gap-2 items-center justify-start border">
                                    <div class="w-12 h-12 flex flex-shrink-0 items-center justify-center text-red-500">
                                        <lucide-icon [img]="icons.FileX" [size]="32"></lucide-icon>
                                    </div>
                                    <div class="flex-grow overflow-hidden text-start text-gray-700">
                                        <div class="truncate" [title]="file.file.name">
                                            {{ getTruncatedFileName(file.file.name, 20) }}
                                        </div>
                                        <div class="w-full h-1 mt-1 bg-gray-200 rounded-full overflow-hidden">
                                            <div class="h-full bg-nside-orange-400 transition-all duration-300"
                                                [style.width.%]="file.progress"></div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="filesControl.valid && selectedFiles.length > 0; else empty">
                                <div *ngFor="let file of selectedFiles"
                                    class="w-full p-2 flex gap-2 items-center justify-start border">
                                    <div class="w-12 h-12 flex flex-shrink-0 items-center justify-center">
                                        <lucide-icon [img]="icons.FileText" [size]="32"></lucide-icon>
                                    </div>
                                    <div class="flex-grow overflow-hidden text-start text-gray-700">
                                        <div class="truncate" [title]="file.file.name">
                                            {{ getTruncatedFileName(file.file.name, 20) }}
                                        </div>
                                        <div class="w-full h-1 mt-1 bg-gray-200 rounded-full overflow-hidden">
                                            <div class="h-full bg-nside-orange-400 transition-all duration-300"
                                                [style.width.%]="file.progress"></div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <ng-template #empty>
                                <p class="text-sm text-gray-400 italic">No files selected</p>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="w-full flex flex-row gap-2 items-center justify-end">
                    <button class="px-4 py-1.5 w-20 rounded-md border border-nside-gray-400 oswald-font"
                        (click)="$event.preventDefault(); handleCloseFileUpload();">
                        Close
                    </button>
                    <button
                        type="submit"
                        class="w-20 flex items-center justify-center px-4 py-1.5 rounded-md border bg-gradient-to-b oswald-font text-white"
                        [ngClass]="{
                        'border-nside-gray-100 from-nside-gray-100 to-nside-gray-200 cursor-not-allowed':
                            filesControl.invalid || selectedFiles.length === 0,
                        'border-nside-orange-100 from-nside-orange-300 to-nside-orange-400 hover:bg-gradient-to-b hover:from-nside-orange-100 hover:to-nside-orange-200':
                            filesControl.valid && selectedFiles.length > 0
                        }"
                        [disabled]="filesControl.invalid || selectedFiles.length === 0"
                        (click)="$event.preventDefault(); handleSaveFiles()"
                    >
                        Save
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<div *ngIf="loading">
    <spinner></spinner>
</div>